webpackJsonp([54],{

/***/ "VVFi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-page_97d0b066bd3f5c2a6bd1c7ced2cecefe.html";

/***/ }),

/***/ "tGmZ":
/***/ (function(module, exports, __webpack_require__) {

var SubscriptionPage = (function () {
    function SubscriptionPage() {
    }
    return SubscriptionPage;
}());
angular.module('animatronApp.SubscriptionPage', [])
    .component('subscriptionPage2', {
    controller: SubscriptionPage,
    templateUrl: __webpack_require__("VVFi")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/54-c7c98a0cc108ea8b91f3.min.js